var _rect, _line, _rect2, _rect3, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpperCabinet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 119,
    viewBox: "0 0 363 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 363,
    height: 119,
    fill: "#B7C8C7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: -8.74228e-8,
    x2: 180,
    y2: 119,
    stroke: "#7F6969",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 150,
    height: 93,
    fill: "#E2E2E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 13,
    width: 150,
    height: 93,
    fill: "#E2E2E2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 76.5,
    r: 7.5,
    fill: "#7F6969"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.5,
    cy: 76.5,
    r: 7.5,
    fill: "#7F6969"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperCabinet);
export default __webpack_public_path__ + "static/media/upper_cabinet.135d09abef7a6bda44c7d0fee6b2d2c7.svg";
export { ForwardRef as ReactComponent };